/* External */
import { memo } from 'react';
import PropTypes from 'prop-types';

/* Ott-common */
import InteractiveElement from '@dtvgo/interactive-element';

/* Utils */
import withInteractiveFocusable from '../../hocs/withInteractiveFocusable.hoc';

/* Styles */
import './FocusableLink.scss';

function FocusableLink({
  children,
  className,
  disabled,
  focused,
  onMouseDown,
  onMouseEnter,
}) {
  return (
    // eslint-disable-next-line jsx-a11y/prefer-tag-over-role -- Accessibility is not a big concern
    <InteractiveElement
      className={
        `dtv-html5-c-focusable-link ${
          focused ? 'dtv-html5-c-focusable-link--focused' : ''
        } ${className}`
      }
      onMouseDown={onMouseDown}
      onMouseEnter={onMouseEnter}
      role="link"
      disabled={disabled}
    >
      <div className="dtv-html5-c-focusable-link__content-text">
        <span>{children}</span>
        <hr className="dtv-html5-c-focusable-link__line" />
      </div>
    </InteractiveElement>
  );
}

FocusableLink.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  focused: PropTypes.bool,
  onMouseDown: PropTypes.func,
  onMouseEnter: PropTypes.func,
};

FocusableLink.defaultProps = {
  children: undefined,
  className: '',
  disabled: false,
  focused: false,
  onMouseDown: undefined,
  onMouseEnter: undefined,
};

export default memo(withInteractiveFocusable()(memo(FocusableLink)));
